function App() {
  return (
    <h1 className="text-3xl font-bold underline text-red">
      Hello world!
    </h1>
  );
}

export default App;
